// ======================================================================
// File: indentStatus.js
// Module: PPE → Procurement → Indent
//
// Purpose:
// - Frontend mirror of backend indent status enum
// - Must always match backend values exactly
//
// Backend source:
// indent_models.py → IndentStatus
//
// ======================================================================

const INDENT_STATUS = {
  DRAFT: "DRAFT",
  SUBMITTED: "SUBMITTED",
  APPROVED: "APPROVED",
  PARTIALLY_ORDERED: "PARTIALLY_ORDERED",
  CLOSED: "CLOSED",
};

export default INDENT_STATUS;
